import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DescriptionListItem from '../../../v2/DescriptionListItem';
import CargomaticInput from '../../../v2/input';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import ShipmentValue from './ShipmentValue';
import { useFormState } from '../hooks/useFormState';
import { Button } from '@cargomatic/ui';

// Edit form component
const EditForm = ({
  dataTestId,
  title,
  value,
  rows,
  onSave,
  onCancel,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div data-testid={dataTestId}>
      <CargomaticInput
        dataTestId="CargomaticInput-2f411f15"
        type="textarea"
        className="mb-4"
        label={title}
        value={value}
        rows={rows}
        onChange={onChange}
      />
      <div data-testid="div-c4861608" className="form-actions space-x-2">
        <Button data-testid="button-c5741bd8" variat="primary" onClick={onSave}>
          {titleize(t('SAVE'))}
        </Button>
        <Button
          data-testid="button-4c134ce2"
          type="button"
          variant="outline"
          onClick={onCancel}
        >
          {t('CANCEL')}
        </Button>
      </div>
    </div>
  );
};

const ShipmentDetailValueItem = ({
  dataTestId,
  title,
  value: propValue,
  rows,
  info,
  infoPosition,
  editable,
  onSave,
}) => {
  const {
    showEdit,
    formValue,
    setFormValue,
    startEditing,
    cancelEditing,
    saveChanges,
  } = useFormState(propValue);

  // Update form value when prop changes and we're not in edit mode
  useEffect(() => {
    if (!showEdit) {
      setFormValue(propValue);
    }
  }, [propValue, showEdit, setFormValue]);

  return (
    <div data-testid={dataTestId}>
      <DescriptionListItem
        dataTestId="DescriptionListItem-a512b612"
        label={title}
        info={info}
        position={infoPosition}
      >
        {showEdit ? (
          <EditForm
            dataTestId={dataTestId}
            title={title}
            value={formValue}
            rows={rows}
            onSave={() => saveChanges(onSave)}
            onCancel={() => cancelEditing(propValue)}
            onChange={(newValue) => setFormValue(newValue)}
          />
        ) : (
          <ShipmentValue
            dataTestId={dataTestId}
            value={propValue}
            editable={editable}
            onEdit={() => startEditing(propValue)}
          />
        )}
      </DescriptionListItem>
    </div>
  );
};

ShipmentDetailValueItem.propTypes = {
  editable: PropTypes.bool,
  rows: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.string,
  info: PropTypes.string,
  infoPosition: PropTypes.string,
  onSave: PropTypes.func,
};

ShipmentDetailValueItem.defaultProps = {
  title: '',
  rows: 1,
  onSave: () => {},
  value: '',
  editable: false,
  info: undefined,
  infoPosition: 'right',
};

export default ShipmentDetailValueItem;
